import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import { Link } from "gatsby"
import RankFirst from "../icons/rank-first"
import RankSecond from "../icons/rank-second"
import RankThird from "../icons/rank-third"
import { formatPercentage } from "../../utils/str"
const styles = theme => ({
  root: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    position: "relative",
    width: "100%",
    padding: "22px 24px",
    margin: "20px 0px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px #254E781A",
  },

  title: {
    marginBottom: "20px",
    fontWeight: "bold",
  },

  subtitle: {
    fontWeight: "bold",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "100%",
    color: "#181819",
    "&:hover": {
      color: "#3d3d40",
    },
  },

  rankContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    width: "100%",
  },

  item: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "33.33%",
    textAlign: "center",
    padding: "0px 10px",
  },

  icon: {
    minWidth: "60px",
    width: "60px",
    height: "60px",
    background: "#040E35",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    marginBottom: "8px",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      minWidth: "50px",
      width: "50px",
      height: "50px",
    },
  },

  headerBlock: {
    width: "35%",
    height: "16px",
    background: "#D8DBDF",
    marginBottom: "10px",
    borderRadius: "2px",
  },

  descBlock: {
    width: "20%",
    height: "13px",
    background: "#D8DBDF",
    borderRadius: "2px",
    marginBottom: "4px",
  },
})

class Ranking extends React.Component {
  // ランキングの部門名の表示を置換する(jsic_l_by_department_rank_stats.nameはconstに合わせて生成しているため)
  replaceName = (name) => {
    let replaceName = name.replace(/・情報通信|・国際|・ロジスティクス|・新事業|・アライアンス|・サステナビリティ/g, '');
    if (name === '秘書') {
      replaceName = '秘書室';
    } else if (name === '品質') {
      replaceName = '品質管理';
    }
    return replaceName;
  }

  render() {
    const { classes, title, id, items, type, path, ...other } = this.props
    if (Array.isArray(items) && items.length >= 3) {
      return (
        <div className={classes.root} id={id} {...other}>
          <h3 className={classes.title}>{title}</h3>
          <div className={classes.rankContainer}>
            <div className={classes.item}>
              <Link to={`${path}/${items[0].key}`} className={classes.icon} aria-label="rank_first">
                <RankFirst width={45} height={43} />
              </Link>
              <Link
                to={`${path}/${items[0].key}`}
                className={classes.subtitle}
                title={this.replaceName(items[0].name)}
              >
                {this.replaceName(items[0].name)}
              </Link>
              <p>{formatPercentage(items[0][`${type}_percentage`])}</p>
            </div>

            <div className={classes.item}>
              <Link to={`${path}/${items[1].key}`} className={classes.icon} aria-label="rank_second">
                <RankSecond width={45} height={43} />
              </Link>
              <Link
                to={`${path}/${items[1].key}`}
                className={classes.subtitle}
                title={this.replaceName(items[1].name)}
              >
                {this.replaceName(items[1].name)}
              </Link>
              <p>{formatPercentage(items[1][`${type}_percentage`])}</p>
            </div>

            <div className={classes.item}>
              <Link to={`${path}/${items[2].key}`} className={classes.icon} aria-label="rank_third">
                <RankThird width={45} height={43} />
              </Link>

              <Link
                to={`${path}/${items[2].key}`}
                className={classes.subtitle}
                title={this.replaceName(items[2].name)}
              >
                {this.replaceName(items[2].name)}
              </Link>

              <p>{formatPercentage(items[2][`${type}_percentage`])}</p>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div
          className={classes.root}
          id={id}
          {...other}
          style={{ pointerEvents: "none" }}
        >
          <h3 className={classes.title}>{title}</h3>
          <div className={classes.rankContainer}>
            <div className={classes.item}>
              <div className={classes.icon} style={{ background: "#71737B" }} aria-label="rank_first">
                <RankFirst width={45} height={43} />
              </div>
              <div className={classes.headerBlock}></div>
              <div className={classes.descBlock}></div>
            </div>

            <div className={classes.item}>
              <div className={classes.icon} style={{ background: "#71737B" }} aria-label="rank_second">
                <RankSecond width={45} height={43} />
              </div>
              <div className={classes.headerBlock}></div>
              <div className={classes.descBlock}></div>
            </div>

            <div className={classes.item}>
              <div className={classes.icon} style={{ background: "#71737B" }} aria-label="rank_third">
                <RankThird width={45} height={43} />
              </div>
              <div className={classes.headerBlock}></div>
              <div className={classes.descBlock}></div>
            </div>
          </div>
        </div>
      )
    }
  }
}

Ranking.propTypes = {
  classes: PropTypes.object.isRequired,
}

Ranking.defaultProps = {}

export default withStyles(styles)(Ranking)
